import { defineReactiveModel, Persistable, SettingsMixin } from "vue-app-utils";
import Model from "@/models/model";

const Setting = {
  extends: Model,
  mixins: [
    Persistable,
    SettingsMixin
  ]
};

export default defineReactiveModel(Setting);
